<ng-container>
  <h2 mat-dialog-title>Sélection des articles du contrat</h2>
  <hr />
  <mat-dialog-content>
    <vex-product-select
      [contracts]="data.contracts"
      [alreadySelected]="data.alreadySelected"
      [supportEstablishment]="data.supportEstablishment"
      #table
    ></vex-product-select>
  </mat-dialog-content>

  <!-- Zone de chargement en bas -->
  <div *ngIf="isProcessing" style="padding: 16px; border-top: 1px solid #e0e0e0; background: #f5f5f5">
    <div style="display: flex; align-items: center; justify-content: center">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="30"
        [style.--mdc-circular-progress-active-indicator-color]="'#1976d2'"
        style="color: #1976d2"
      ></mat-progress-spinner>
      <span style="margin-left: 16px; font-size: 14px; color: #666">Ajout des articles en cours...</span>
    </div>
  </div>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button (click)="closeDialog()" [disabled]="isProcessing">Annuler</button>
    <button mat-button color="primary" [disabled]="!table.hasSelection() || isProcessing" (click)="validate()">
      <span *ngIf="!isProcessing">Valider</span>
      <span *ngIf="isProcessing">Traitement...</span>
    </button>
  </mat-dialog-actions>
</ng-container>
